import Swiper from 'swiper';

export default class ProjectDevelopment {

    constructor() {
        this.initLogos();
    }

    initLogos() {
        if (document.querySelector('#logoSlider')) {
            const swiper = new Swiper('#logoSlider .swiper-container', {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                },
            });
        }
    }
}
